import axiosApi from "helpers/api_helper";

export async function login({ values, navigate }) {
  console.log("Login values:", values);

  const loginData = {
    email: values.email,
    password: values.password,
  };

  try {
    const response = await axiosApi.post("/player/login", loginData);
    console.log('data', response);
    const token = response.data.accessToken;
    const refresh_token = response.data.refreshToken;
    localStorage.setItem('auth_token', token);
    localStorage.setItem('ref_token', refresh_token);

    // Also store for compatibility with existing auth check
    // localStorage.setItem("authUser", token);

    // Return response data before navigation
    const result = response.data;
    console.log(result);

    // Navigate after everything is successful
    navigate("/accueille");
    // navigate("/profile");

    return result;
  } catch (error) {
    console.error("Login error:", error);
    console.log(error?.response?.data);
    return error?.response?.data;
  }
}
export async function submitProof(values) {
  try {
    const response = await axiosApi.post("/player/submitPaymentProof", values);
    const result = response.data;
    return result;
  } catch (error) {
    console.error("submitProof error:", error);
    console.log(error?.response?.data);
    return error?.response?.data;
  }
}
export async function sendResetPasswordEmail(values) {
  try {
    const response = await axiosApi.post("/player/forgetPassword", { email: values }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    // const result = response.data;
    const result = {
      status: true,
      message: response.data.message,
    }
    return result;
  } catch (error) {
    console.error("sendResetPasswordEmail error:", error);
    console.log(error?.response?.data);
    // return error?.response?.data;
    const result = {
      status: false,
      message: error?.response?.data?.message || "Error in sending reset password to email",
    }
    return result;
  }
}

export async function verifyCodeAndResetPassword(values) {
  try {
    const response = await axiosApi.post("/player/resetPassword", { code: values.code, password: values.newPassword }, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    // const result = response.data;
    const result = {
      status: true,
      message: response.data.message || 'Password has been reset successfully.',
    }
    return result;
  } catch (error) {
    console.error("sendResetPasswordEmail error:", error);
    console.log(error?.response?.data);
    const result = {
      status: false,
      message:
        error?.response?.data?.message ||
        error?.message ||
        'Une erreur est survenue, veuillez réessayer.',
    }
    // return error?.response?.data;
    return result;
  }
}

export async function register(values) {
  const formData = new FormData();

  // Loop through the values and append them to formData
  for (const key in values) {
    if (key === 'isReferred') {
      if (values[key] === 'oui') {
        formData.append(key, true);
      } else {
        formData.append(key, false);
      }
      continue;
    }
    if (key === 'referralCode') {
      if (values[key] !== '') {
        formData.append(key, values[key])
      }
      continue
    }
    if (values[key] instanceof File) {
      // If the value is a file, append it as a file
      formData.append(key, values[key]);
    } else if (key === 'previousClubs') {
      // Si c'est previousClubs, traiter comme un tableau
      if (typeof values[key] === 'string') {
        // Si c'est une chaîne, la diviser d'abord
        const clubs = values[key].split(',').map(club => club.trim());
        clubs.forEach(club => {
          formData.append('previousClubs[]', club);
        });
      } else if (Array.isArray(values[key])) {
        // Si c'est déjà un tableau
        values[key].forEach(club => {
          formData.append('previousClubs[]', club);
        });
      }
    } else {
      // Otherwise, append the value as text
      formData.append(key, values[key]);
    }
  }

  try {
    const response = await axiosApi.post('/player/register', formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Ensure correct content type
      },
    });
    return response.data; // Return the response data if the request is successful
  } catch (error) {
    console.error('Error during registration:', error);
    throw error; // Rethrow the error so it can be handled by the caller
  }
}
